import { render, staticRenderFns } from "./RightBar.vue?vue&type=template&id=74de04f4&"
import script from "./RightBar.vue?vue&type=script&lang=js&"
export * from "./RightBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports